var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../abstract-authenticated-service';
import GetUserSettingsTask from '../../../model/task/organisation/get-user-settings-task';
import GetUserTask from '../../../model/task/organisation/get-user-task';
import GetUsersTask from '../../../model/task/organisation/get-users-task';
import PatchUserProfileTask from '../../../model/task/organisation/patch-user-profile-task';
import PutUserSettingsTask from '../../../model/task/organisation/put-user-settings-task';
export default class UserService extends AbstractAuthenticatedService {
    /**
     * Returns matching users
     *
     * @returns
     */
    findUsers(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetUsersTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            return this.runTask(task);
        });
    }
    /**
     * Loads a user
     *
     * @param id
     * @returns
     */
    loadUser(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetUserTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Updates the current user's profile
     *
     * @param profile
     * @returns
     */
    updateUserProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PatchUserProfileTask();
            task.token = this.token;
            task.profile = profile;
            return this.runTask(task);
        });
    }
    /**
     * Callback function for form options
     *
     * @param search
     * @returns
     */
    formOptionsCallback(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const users = yield this.findUsers({
                searchTerm: search,
                disabled: false,
                order: [
                    {
                        key: 'firstName',
                        descending: false,
                    },
                    {
                        key: 'lastName',
                        descending: false,
                    },
                ],
            });
            const options = [];
            for (const user of users.results) {
                options.push({
                    value: user.id,
                    title: user.fullName,
                });
            }
            return options;
        });
    }
    /**
     * Callback function for form titles
     *
     * @param values
     * @returns
     */
    formTitlesCallback(values) {
        return __awaiter(this, void 0, void 0, function* () {
            const users = yield this.findUsers({
                id: values,
                order: [
                    {
                        key: 'firstName',
                        descending: false,
                    },
                    {
                        key: 'lastName',
                        descending: false,
                    },
                ],
            });
            const options = {};
            for (const user of users.results) {
                if (!user.id) {
                    continue;
                }
                options[user.id] = user.fullName;
            }
            return options;
        });
    }
    /**
     * Loads user settings
     *
     * @param userId
     * @returns
     */
    loadUserSettings(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetUserSettingsTask();
            task.token = this.token;
            task.userId = userId;
            return this.runTask(task);
        });
    }
    /**
     * Saves user settings
     *
     * @param userId
     * @param settings
     * @returns
     */
    saveUserSettings(userId, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutUserSettingsTask();
            task.token = this.token;
            task.userId = userId;
            task.settings = settings;
            return this.runTask(task);
        });
    }
}
//# sourceMappingURL=user-service.js.map